/** Browser hints for the OCR branch in paxton_app/file_pipeline/type_policy.py; the worker verifies actual content. */
export function requiresOcrForUpload(file: File): boolean {
  const name = file.name.trim().replace(/[. \t]+$/u, '')
  const contentType = file.type.toLowerCase().split(';')[0].trim()
  return /\.(pdf|heic|jpe?g|png|tiff?)$/i.test(name) || ['application/pdf', 'image/heic', 'image/jpeg', 'image/png', 'image/tiff'].includes(contentType)
}
